export default __webpack_public_path__ + "static/media/columnsHover.030e6880.svg";